{
  "id": "athena",
  "pantheon": "greeks",
  "name": {
    "pt-BR": "Atena",
    "en": "Athena"
  },
  "icon": "gods/athena",
  "portrait": "gods/athena-portrait",
  "age": "classical",
  "freeUnitsOnAgeUp": {
    "minotaur": 1
  },
  "unlocks": ["minotaur", "labyrinth-of-minos", "aegis-shield", "sarissa"],
  "powers": ["restoration"],
  "meta": {
    "source": "Game files 19.17020 (techtree.xml)",
    "checkedAt": "2026-10-18",
    "confidence": "high",
    "note": "ClassicalAgeAthena: CreateUnit Minotaur at a Temple (one free myth unit), god power Restoration (cooldown 180 s); enables the listed unit and techs."
  }
}
